import { Box, Button } from '@mui/material';
import { MUIStyledCommonProps } from '@mui/system';
import { Theme } from '@emotion/react';
import { ICountry } from '../../../models/ICountry';
import { ReactComponent as TrashIcon } from '../../../assets/icons/trash.svg';

import IMTitle from '../../../components/typography/IMText';

type Props = {
	country: ICountry;
	onDeleteClick: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
} & MUIStyledCommonProps<Theme>;

const CountryRect = ({ country, onDeleteClick, sx, ...props }: Props) => {
	return (
		country && <Box
			sx={{
				position: 'relative',
				backgroundImage: `url("assets/countries/${country?.country_name}.webp?x=1")`,
				backgroundSize: 'cover',
				borderRadius: '12px',
				overflow: 'hidden',
				display: 'flex',
				...sx,
			}}
			{...props}
		>
			<Box
				sx={{
					position: 'relative',
					display: 'flex',
					height: '100%',
					width: '100%',
					background:
						'linear-gradient(180deg, rgba(0, 0, 0, 0) -0.21%, rgba(0, 0, 0, 0) 49.9%, rgba(0, 0, 0, 0.8) 100%)',
				}}
			>
				<Box
					sx={{
						position: 'relative',
						display: 'flex',
						alignItems: 'end',
						margin: '12px',
						width: 'calc(100% - 24px)',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'end',
							width: '100%',
						}}
					>
						<Button
							sx={{
								position: 'absolute',
								right: '0px',
								top: '0px',
								width: '36px',
								minWidth: '36px',
								height: '36px',
								border: '1px solid #0000000D',
								borderRadius: '8px',
								backgroundColor: '#FFFFFF',
								padding: 0,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								cursor: 'pointer',
							}}
							onClick={(e) => onDeleteClick(e)}
						>
							<TrashIcon />
						</Button>
						<IMTitle
							weight="700"
							size="14px"
							color="#FFFFFF"
							textAlign="left"
							props={{
								overflow: 'hidden',
								margin: '0 5px 0 0',
								width: '100%',
								display: 'inline-block',
							}}
						>
							{country.country_name_ru}
						</IMTitle>
						<IMTitle
							weight="700"
							size="14px"
							color="#FFFFFF"
							textAlign="center"
							props={{
								flexShrink: 0,
							}}
						>
							{Math.floor(country.total_score || 0)}
						</IMTitle>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default CountryRect;
